import React from 'react';
import {MoneyApi} from "../../../../../../services/Api/types";
import Money from "../../../../../../components/Common/Money";
import ProductNonConfigurableSubItem from "./ProductNonConfigurableSubItem";

interface Props {
    name: string;
    price?: MoneyApi;
    modifierGroups?: Record<string, any>[];
    quantity?: number;
}

const ProductNonConfigurableItem = ({name, price, modifierGroups, quantity}: Props) => {
    const drawName = () => {
        if (quantity && quantity > 1) {
            return `${quantity}x ${name}`
        }

        return name;
    }

    return (
        <div className="product-non-configurable-item d-flex flex-column">
            <div className="d-flex align-items-center justify-content-between gap-2">
                <p>{drawName()}</p>
                {price && price.amount > 0 && (
                    <p className="price"><Money value={price}/></p>
                )}
            </div>
            {
                modifierGroups && modifierGroups.length > 0 && modifierGroups.map(modifierGroup => {
                    return modifierGroup.options.map((option: Record<string, any>) => (
                        <ProductNonConfigurableSubItem key={`${modifierGroup.id}-${option.id}`} item={option}/>
                    ))
                })
            }
        </div>
    )
}

export default ProductNonConfigurableItem;